export default __webpack_public_path__ + "static/media/lottery_game_banner.650ea0d1.png";